import React, {useEffect, useRef, useState} from 'react';
import {useGetAddressTypesQuery} from '../../redux/rtk/injectedMappingApi';
import {useLazyGetHereAddressQuery} from '../../redux/rtk/injectedHereAddressApi';
import {useFieldArray} from 'react-hook-form';
import Input from '../global/Input';
import {Button} from 'primereact/button';
import {TabPanel, TabView} from 'primereact/tabview';
import {RadioButton} from 'primereact/radiobutton';
import CustomDialog from '../global/CustomDialog';
import MapOl from '../geoData/map';
import LayersMapOl from '../geoData/layer/LayersMapOl';
import BaseLayers from '../geoData/layer/BaseLayers';
import {getMapCenter} from '../../functions/functionsOpenlayer';
import {setBaseLayer, setBaseWorkspace, setWorkspace} from '../../redux/slices/GeomonitoringSlice';
import {useAppDispatch, useAppSelector} from '../../redux/hooks';
import geoSettings from '../../config/geoSettings';
import PoiLayer from '../geoData/layer/PoiLayer';
import {getGeoLocation, MobileDevice, openAppleMaps, openGoogleMaps} from '../functions/Global';
import {classNames} from 'primereact/utils';
import {getValue} from '@testing-library/user-event/dist/utils';

type AddressProps = {
    projectId: string,
    t: any,
    getFormErrorMessage: (name: string) => void,
    form: any,
    istJuristisch: boolean,
    edit: boolean,
    addressData: any,
    geoData?: any
}

const IMG_SIZE = 15;

export const AddressForm = (props: AddressProps) => {
    const t = props.t;

    // console.log(props);
    const [activeTabIndex, setActiveTabIndex] = useState<number>(0);
    const [formerTabIndex, setFormerIndex] = useState<number>(0);
    //  const [addressIndex, setAddressIndex] = useState<number>(0);
    const [addressTypes, setAddressTypes] = useState<any>([]);
    const [keepAddress, setKeepAddress] = useState('');
    const [pois, setPois] = useState<any>({data: {}});
    const [zoomTo, setZoomTo] = useState<any>(null);
    const [showAddressDialog, setShowAddressDialog] = useState<boolean>(false);
    const [addressSuggestion, setAddressSuggestion] = useState([]);
    const [triggerHereAddress, resultHereAddress, lastPromiseInfoHereAddress] = useLazyGetHereAddressQuery();
    const [center, setCenter] = useState([0, 0]);
    const [zoom, setZoom] = useState(9);
    const [isMapActive, setIsMapActive] = useState<boolean>(false);
    const [selectedAddressTypeId, setSelectedAddressTypeId] = useState<number>(0);

    const id = 'adresse';
    const refKeepAddress = useRef(keepAddress);
    const hereAddress = resultHereAddress;
    const addressTypesQuery = useGetAddressTypesQuery();
    const dispatch = useAppDispatch();
    const getFormErrorMessage = props.getFormErrorMessage;

    const {control, formState: {errors}, handleSubmit, setValue, getValues, watch} = props.form;

    const mobileDevice: MobileDevice = useAppSelector((state: any) => state.globalInfoData.mobileDevice);

    const {fields, append, prepend, remove, swap, move, insert} = useFieldArray({
        control, // control props comes from useForm (optional: if you are using FormContext)
        name: id, // unique name for your Field Array
    });

    const hideAddressDialog = () => {
        setShowAddressDialog(false);
    };


    const setValueBasedByKey = (fieldkey: string, newValue: string, index: any, test4Value: any) => {
        if (hereAddress.data.address[test4Value]) {
            setValue(id + '.' + index + '.' + fieldkey, newValue);
        }

    };

    const assignAddress = () => {
        if (refKeepAddress.current === 'newData') {
            const newAddress = hereAddress.data.address;
            const index = hereAddress.data.index;
            setValueBasedByKey('strassehausnummer', newAddress.street + ' ' + newAddress.houseNumber, index, 'street');
            setValueBasedByKey('plz', newAddress.postalCode, index, 'postalCode');
            setValueBasedByKey('ort', newAddress.city, index, 'city');
            setValue(`${id}.${index}.geo_position`, {position: hereAddress.data.position});

        }
        hideAddressDialog();
    };

    const isSetAddress = (currentAdress: any) => {
        let addressSet = false;
        if (currentAdress.plz > 0 || (currentAdress.ort && currentAdress.ort.length > 2)) {
            addressSet = true;
        }
        return addressSet;
    };

    const validateAddress = (index: number, data: any) => {
        if (data.adresse && data.adresse.length > 0) {
            let currentAdress = data.adresse[index];
            if (isSetAddress(currentAdress)) {
                currentAdress = {...currentAdress, ...{index: index}};
                triggerHereAddress(currentAdress);

                // setShowAddressDialog(true);
            }
        }
    };

    const getMapCenterData = () => {
        const baseWorkspace = props.geoData.baselayer_workspace !== null ? props.geoData.baselayer_workspace : geoSettings.wmsWorkspace;
        const mapCenterData = getMapCenter({project: props.geoData});
        dispatch(setWorkspace(props.geoData.geoserver_workspace));
        dispatch(setBaseLayer(props.geoData.base_layer));
        dispatch(setBaseWorkspace(baseWorkspace));
        setZoom(mapCenterData.zoom);
        setCenter(mapCenterData.center);
    };

    const isChangedAddress = () => {
        let isChanged = false;
        const newAddress = hereAddress.data.address;
        const oldAddress = hereAddress.data.oldData;
        const keys = Object.keys(newAddress);
        const newAddressStreet = newAddress.street ? (newAddress.street).replace(/ /g, '') : newAddress.street;

        switch (true) {
            case ((oldAddress.strassehausnummer).replace(/ /g, '') !== (newAddressStreet + newAddress.houseNumber)) && keys.indexOf('street') >= 0:
                // console.log((oldAddress.strassehausnummer).replace(/ /g, ''),newAddress.street + newAddress.houseNumber,keys.indexOf('street') >= 0);
                isChanged = true;
                break;
            case oldAddress.plz !== newAddress.postalCode:
                // console.log(oldAddress.plz,newAddress.postalCode);
                isChanged = true;
                break;
            case oldAddress.ort !== newAddress.city:
                // console.log(oldAddress.ort,newAddress.city);
                isChanged = true;
                break;
        }
        return isChanged;
    };


    const getAddressDialogContent = () => {
        if (hereAddress.status === 'fulfilled') {
            const oldData = hereAddress.data.oldData;
            const addressFieldOrigin = (
                <div>{t('projectManagement:dialogs.sugestedAddress.enteredAddress')}:<br/> {oldData.strassehausnummer} {oldData.plz} {oldData.ort}
                </div>);
            const addressFieldSuggestion = (
                <div>{t('projectManagement:dialogs.sugestedAddress.suggestedAddress')}:<br/> {hereAddress.data.address.label}
                </div>);
            const joinedFields =
                (<div>
                    <div className="grid">
                        <div className="col">
                            <div className="text-center p-3 border-round-sm">
                                <div className="flex align-items-center">
                                    <RadioButton inputId="address1" name="addressRadio" value={'oldData'}
                                                 onChange={(e) => setKeepAddress(e.value)}
                                                 checked={refKeepAddress.current === 'oldData'}/>
                                    <label htmlFor="address1" className="ml-2">{addressFieldOrigin}</label>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="text-center p-3 border-round-sm">

                                <div className="flex align-items-center">
                                    <RadioButton inputId="address2" name="addressRadio" value={'newData'}
                                                 onChange={(e) => setKeepAddress(e.value)}
                                                 checked={refKeepAddress.current === 'newData'}/>
                                    <label htmlFor="address2" className="ml-2">{addressFieldSuggestion}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={'w-full text-center'}>
                        <Button className="layout-inline-menu-action"
                                label={t('projectManagement:dialogs.sugestedAddress.enterOwnAddress')}
                                onClick={hideAddressDialog}/>
                    </div>
                </div>);
            // @ts-ignore
            setAddressSuggestion(joinedFields);
        }
        // return joinedFields;
    };

    const getTypeDataHere = (index: number) => {
        let type = {};
        // console.log(poisArray.data);
        if (props.addressData && props.addressData[index]) {
            const address = props.addressData[index];
            type = {
                adresse_type_id: address.adresse_type_id,
                ladungsadresse: address.ladungsadresse,
                postadresse: address.postadresse
            };
        } else {
            type = {
                adresse_type_id: getValues(`${id}.${index}.adresse_type_id`),
                ladungsadresse: getValues(`${id}.${index}.ladungsadresse`),
                postadresse: getValues(`${id}.${index}.postadresse`)
            };
        }
        return type;
    };

    const setPoisData = (index: number, position: any) => {
        const poisArray = pois;
        const type = getTypeDataHere(index);
        poisArray.data[index] = {position: position, typeData: type, index: index};
        setPois({data: {...{}, ...poisArray.data}, index: index});
        setValue(`${id}.${index}.geo_position`, {position: position});
    };

    const isAddressSameLegalForm = (adresse_type_id: number) => {
        for (let i = 0; i < addressTypes.length; i++) {
            let aT = addressTypes[i];

            if (aT.value === adresse_type_id) {
                return true;
            }
        }
        return false;
    };

    useEffect(() => {
        getMapCenterData();
    }, []);

    useEffect(() => {
            //  console.log(hereAddress);
            if (hereAddress.isSuccess && hereAddress.data.found) {
                //          console.log(pois,hereAddress.data)
                setPoisData(hereAddress.data.index, hereAddress.data.position);
                //   console.log(hereAddress.data.position)
                if (isChangedAddress()) {
                    getAddressDialogContent();
                    setShowAddressDialog(true);
                }

            }
        },
        [hereAddress.data]);

    useEffect(() => {
        // console.log(addressTypes);
    }, [addressTypes]);

    const onBlurFn = (index: number) => {
        validateAddress(index, getValues());
    };

    const getAddressTypeName = (id: number) => {
        let result = '';

        if (addressTypes.length > 0) {
            const temp = addressTypes.filter((item: any) => {
                return item.value === id;
            });

            if (temp.length > 0) {
                result = temp[0].name;
            }
        }
        return result;
    };

    const getAddress = (field: any, index: number, watchAddressType: any) => {
        // console.log('address', field, index);
        return (<div key={field.id}>
            <div className={'grid mt-3'}>
                <div className={'col-6'}>
                    <Input
                        type="dropdown" edit={props.edit} name={`${id}.${index}.adresse_type_id`}
                        label={t('globalData:persons.addressType')}
                        dropdownOptions={addressTypes}
                        validationControl={control}
                        validationErrorMessage={getFormErrorMessage}
                        validationRules={{
                            required: false,
                            // required: t('globalData:persons.streetHouseNr') + ' ' + t('input:required')
                        }}
                    />
                </div>
                <div className={'col-6 mt-auto flex'}>
                    {/*<Button label={t('globalData:buttons.addressResearch')}/>*/}
                    {props.edit &&
                        <Button className={'p-button-rounded p-button-danger p-button-text'} style={{float: 'right'}}
                                type={'button'}
                                icon={'pi pi-trash'}
                                onClick={() => {
                                    remove(index);
                                    setAvailableTabIndex();

                                    if (fields.length > 0) {
                                        let hasPost = false;
                                        let hasLadung = false;

                                        for (let i = 0; i < fields.length; i++) {
                                            const post = getValues(`${id}.${i}.postadresse`);
                                            const ladung = getValues(`${id}.${i}.ladungsadresse`);

                                            if (post) {
                                                hasPost = true;
                                            }
                                            if (ladung) {
                                                hasLadung = true;
                                            }

                                            if (post && ladung) {
                                                break;
                                            }
                                        }

                                        if (!hasPost) {
                                            setValue(`${id}.${0}.postadresse`, true);
                                        }

                                        if (!hasLadung) {
                                            setValue(`${id}.${0}.ladungsadresse`, true);
                                        }
                                    }
                                }}/>}
                    {/* {(mobileDevice === MobileDevice.Android || mobileDevice === MobileDevice.iOS) &&*/}
                    {/* <Button className={'p-button-rounded p-button-info p-button-text p-button-lg'} type={'button'}*/}
                    {/*    icon={'pi pi-car'}*/}
                    {/*    onClick={() => {*/}
                    {/*        getGeoLocation((position) => {*/}
                    {/*           // console.log(position);*/}
                    {/*            const streetHnr = getValues(`${id}[${index}].strassehausnummer`);*/}
                    {/*            const plz = getValues(`${id}[${index}].plz`);*/}
                    {/*            const ort = getValues(`${id}[${index}].ort`);*/}

                    {/*            switch (mobileDevice) {*/}
                    {/*                case MobileDevice.Android:*/}
                    {/*                    openGoogleMaps(position.coords.latitude + ',' + position.coords.longitude, streetHnr + ' ' + plz + ' ' + ort);*/}
                    {/*                    break;*/}

                    {/*                case MobileDevice.iOS:*/}
                    {/*                    openAppleMaps(position.coords.latitude + ',' + position.coords.longitude, streetHnr + ' ' + plz + ' ' + ort);*/}
                    {/*                    break;*/}
                    {/*            }*/}
                    {/*        });*/}
                    {/*    }}/>}*/}
                </div>
            </div>
            <div className={'grid'}>
                <div className={'col-6'}>
                    <Input
                        edit={props.edit}
                        label={isPostfach(watchAddressType) ? t('globalData:persons.poBox') : t('globalData:persons.streetHouseNr')}
                        name={`${id}[${index}].strassehausnummer`}
                        onBlur={() => onBlurFn(index)}
                        validationControl={control} validationErrorMessage={getFormErrorMessage}
                        validationRules={{
                            required: false,
                            // required: t('globalData:persons.streetHouseNr') + ' ' + t('input:required')
                        }}
                    />
                </div>
                <div className={'col-6 m-auto'}>
                    <Input
                        noMargin={true}
                        edit={props.edit} label={t('globalData:persons.ladungsadresse')}
                        name={`${id}.${index}.ladungsadresse`}
                        type={'checkbox'}
                        onChange={(e) => {
                            if (e.checked) {
                                for (let i = 0; i < fields.length; i++) {
                                    if (index !== i) {
                                        setValue(`${id}.${i}.ladungsadresse`, false);
                                    }
                                }
                            } else {
                                setValue(`${id}.${index}.ladungsadresse`, true);
                            }
                        }}
                        validationControl={control} validationErrorMessage={getFormErrorMessage}
                        validationRules={{
                            required: false,
                            // required: t('globalData:persons.streetHouseNr') + ' ' + t('input:required')
                        }}
                    />
                    <Input
                        noMargin={true}
                        edit={props.edit} label={t('globalData:persons.postadresse')}
                        name={`${id}.${index}.postadresse`}
                        type={'checkbox'}
                        onChange={(e) => {
                            if (e.checked) {
                                for (let i = 0; i < fields.length; i++) {
                                    if (index !== i) {
                                        setValue(`${id}.${i}.postadresse`, false);
                                    }
                                }
                            } else {
                                setValue(`${id}.${index}.postadresse`, true);
                            }
                        }}
                        validationControl={control} validationErrorMessage={getFormErrorMessage}
                        validationRules={{
                            required: false,
                            // required: t('globalData:persons.plz') + ' ' + t('input:required')
                        }}
                    />
                </div>
                {!isPostfach(watchAddressType) && <div className={'col-6'}>
                    <Input
                        edit={props.edit} label={t('globalData:persons.plz')} name={`${id}.${index}.plz`}
                        onBlur={() => onBlurFn(index)}
                        validationControl={control} validationErrorMessage={getFormErrorMessage}
                        validationRules={{
                            required: false,
                            // required: t('globalData:persons.plz') + ' ' + t('input:required')
                        }}
                    />
                </div>}
                {!isPostfach(watchAddressType) && <div className={'col-6'}>
                    <Input
                        edit={props.edit} label={t('globalData:persons.city')} name={`${id}.${index}.ort`}
                        onBlur={() => onBlurFn(index)}
                        validationControl={control} validationErrorMessage={getFormErrorMessage}
                        validationRules={{
                            required: false
                            // required: t('globalData:persons.city') + ' ' + t('input:required')
                        }}
                    />
                </div>}
                {!isPostfach(watchAddressType) && <div className={'col-6'}>
                    <Input
                        edit={props.edit} label={t('globalData:persons.ortsteil')}
                        name={`${id}.${index}.ortsteil`}
                        validationControl={control} validationErrorMessage={getFormErrorMessage}
                        validationRules={{
                            required: false
                            // required: t('globalData:persons.city') + ' ' + t('input:required')
                        }}
                    />
                </div>}
            </div>
            {watchAddressType === 5 && <div className={'grid'}>
                <div className={'col-6'}>
                    <Input
                        edit={props.edit} label={t('globalData:persons.abteilung')}
                        name={`${id}.${index}.abteilung`}
                        validationControl={control} validationErrorMessage={getFormErrorMessage}
                        validationRules={{
                            required: false
                            // required: t('globalData:persons.city') + ' ' + t('input:required')
                        }}
                    />
                </div>
                <div className={'col-6'}>
                    <Input
                        edit={props.edit} label={t('globalData:persons.gebaeude')}
                        name={`${id}.${index}.gebaeude`}
                        validationControl={control} validationErrorMessage={getFormErrorMessage}
                        validationRules={{
                            required: false
                            // required: t('globalData:persons.city') + ' ' + t('input:required')
                        }}
                    />
                </div>
                <div className={'col-6'}>
                    <Input
                        edit={props.edit} label={t('globalData:persons.etage')} name={`${id}.${index}.etage`}
                        validationControl={control} validationErrorMessage={getFormErrorMessage}
                        validationRules={{
                            required: false
                            // required: t('globalData:persons.city') + ' ' + t('input:required')
                        }}
                    />
                </div>
                <div className={'col-6'}>
                    <Input
                        edit={props.edit} label={t('globalData:persons.zimmer')}
                        name={`${id}.${index}.zimmer`}
                        validationControl={control} validationErrorMessage={getFormErrorMessage}
                        validationRules={{
                            required: false
                            // required: t('globalData:persons.city') + ' ' + t('input:required')
                        }}
                    />
                </div>
            </div>}
        </div>);
    };

    const getImgSrc = (adress_type_id: number, post: boolean, lade: boolean, name?: string) => {
        let suffix = '';

        if (post && lade) {
            suffix = '_postLade';
        } else if (post) {
            suffix = '_post';
        } else if (lade) {
            suffix = '_lade';
        }

        return `${geoSettings.livingTypeImageUrl}/${(name ? name.toLowerCase() : getAddressTypeName(adress_type_id).toLowerCase()) + suffix}.png`;
    };

    const isPostfach = (id: number) => {
        return id === 2 || id === 12;
    };

    const setAvailableTabIndex = () => {
        for (let i = 0; i < fields.length; i++) {
            if (isAddressSameLegalForm(getValues(`${id}.${i}.adresse_type_id`))) {
                setActiveTabIndex(i);
                break;
            }
        }
    };


    useEffect(() => {
        if (addressTypesQuery.data) {
            setAddressTypes(addressTypesQuery.data.filter((item: any) => {
                return item.ist_juristisch === props.istJuristisch;
            }).map((item: any) => {
                return {
                    name: item.name,
                    label: <div className={'flex'}><img className={'mr-1 my-auto'}
                                                        src={getImgSrc(item.id, false, false, item.name)}
                                                        width={IMG_SIZE}
                                                        height={IMG_SIZE}/>
                        <div className={'my-auto'}>{item.name}</div>
                    </div>,
                    value: item.id
                };
            }));
        }
    }, [props.istJuristisch, addressTypesQuery.data]);

    useEffect(() => {
        setAvailableTabIndex();
    }, [addressTypes, fields]);

    useEffect(() => {
        if (props.addressData !== null) {
            //           console.log(props.addressData);
            const transferGeoPositon = () => {
                //      console.log('transfer', props.addressData)
                for (const i in props.addressData) {
                    const address = props.addressData[i];
                    const geoPosition = address.geo_position;
                    const type = {
                        adresse_type_id: address.adresse_type_id,
                        ladungsadresse: address.ladungsadresse,
                        postadresse: address.postadresse
                    };
                    if (geoPosition !== null) {
                        const data = {
                            position: {lng: geoPosition.coordinates[0], lat: geoPosition.coordinates[1]},
                            index: i,
                            typeData: type
                        };
                        const poisArray = pois;

                        poisArray.data[i] = data;
                        setPois({data: {...{}, ...poisArray.data}, index: 0});
                        setValue(`${id}.${i}.geo_position`, data);
                    } else {
                        validateAddress(parseInt(i), getValues());
                    }

                }
            };
            setTimeout(transferGeoPositon, 2000);
        }
    }, [props.addressData]);

    useEffect(() => {
        refKeepAddress.current = keepAddress;
        getAddressDialogContent();
    }, [keepAddress]);

    return (<div className={'row address-form'}>
        <div className={'surface-border border-1'}>
            <MapOl key={'adresspreview_maps'} zoom={zoom} center={center} divHeight={'30vH'} toolkitEnabled={false}
                   mapActive={false}
                   position={'relative'}
                   propElem={{project: props.geoData}}>
                <LayersMapOl key={props.projectId + '_layerMaps'}>
                    <BaseLayers projectId={props.projectId} mapDataWorkBench={props.geoData.baselayer_workspace}
                                baseLayer={props.geoData.baseLayer ? props.geoData.baseLayer : 'gm_layer_maps'}/>
                    <PoiLayer pois={pois} zoomTo={0}/>
                </LayersMapOl>
            </MapOl>
        </div>
        <div className={'relative'}>
            <div className={'py-3 grid grid-nogutter'}>
                {props.edit && <>
                    <div className={'col-6'}>
                        <Input
                            type="dropdown" edit={props.edit} name={`adresse_type_id`}
                            label={t('globalData:persons.addressType')}
                            dropdownOptions={addressTypes}
                            value={selectedAddressTypeId}
                            onChange={(e: any) => {
                                setSelectedAddressTypeId(e.target.value);
                            }}
                        />
                    </div>
                    <div className={'col mt-auto ml-3'}>
                        <Button
                            className={'p-button-success p-button-outlined p-button-icon-only'}
                            disabled={selectedAddressTypeId === 0}
                            type={'button'} icon={'pi pi-plus'} onClick={() => {
                            append({
                                'abteilung': '',
                                'adresse_type_id': selectedAddressTypeId,//props.istJuristisch ? 7 : 1,
                                'epsg_code': 0,
                                'etage': '',
                                'gebaeude': '',
                                'geo_position': '',
                                'ort': '',
                                'ortsteil': '',
                                'person_id': '',
                                'plz': '',
                                'strassehausnummer': '',
                                'zimmer': '',
                                'postadresse': fields.length <= 0,
                                'ladungsadresse': fields.length <= 0,
                            });
                            setSelectedAddressTypeId(0);

                            // let adresse_types_ids = addressTypes.map((item: any) => {
                            //     return item.id;
                            // });
                            //
                            // for (let i = 0; i < fields.length; i++) {
                            //     let field = fields[i];
                            //     let adresse_type_id = getValues(`${id}.${i}.adresse_type_id`);
                            //
                            //     if (adresse_types_ids.indexOf(adresse_type_id) >= 0) {
                            //         setActiveTabIndex(i);
                            //         break;
                            //     }
                            // }
                        }}/></div>
                    <div className={'col mt-auto ml-3'}>
                        <Button disabled={true} className={'mt-3'} label={t('globalData:buttons.addressResearch')}/>
                    </div>
                </>}

            </div>
            <TabView activeIndex={activeTabIndex} onTabChange={(e: any) => {
                setFormerIndex(activeTabIndex);
                setActiveTabIndex(e.index);
                setZoomTo(e.index);
            }}>
                {fields.map((field, index) => {
                    const watchAddressType = watch(`${id}.${index}.adresse_type_id`);
                    if (isAddressSameLegalForm(watchAddressType)) {
                        const value = getAddressTypeName(watchAddressType);
                        if (value) {
                            const post = watch(`${id}.${index}.postadresse`);
                            const lade = watch(`${id}.${index}.ladungsadresse`);

                            const imgSrc = getImgSrc(watchAddressType, post, lade);

                            const header = (<div className={'flex'}>
                                {imgSrc &&
                                    <img className={'mr-1 my-auto'} src={imgSrc} width={IMG_SIZE} height={IMG_SIZE}/>}
                                <div className={'my-auto'}>{value}</div>
                            </div>);

                            return (<TabPanel key={watchAddressType + '_' + index} header={header}>
                                {getAddress(field, index, watchAddressType)}
                            </TabPanel>);
                        }
                    }
                })}
            </TabView>
        </div>
        <CustomDialog
            header={t('projectManagement:dialogs.sugestedAddress.header')}
            onCancel={hideAddressDialog}
            onHide={hideAddressDialog}
            visible={showAddressDialog}
            maximized={false}
            onClick={assignAddress}>
            {addressSuggestion}
        </CustomDialog>
    </div>);
};
